<template>
  <b-row v-if="ticket_progression_context_loaded" class="m-0 pr-2 pl-2">
    <b-container fluid class="white-box">
      <highcharts :options="chartOptions"></highcharts>
    </b-container>
  </b-row>
  <loader-box v-else height="408px" class="mr-2 mb-2 ml-2"/>
</template>

<script>
import Highcharts from 'highcharts'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    LoaderBox
  },
  computed: {
    ticket_progression_context_loaded() { return this.$store.getters.ticket_progression_context_loaded },
    daily_sales() { return this.$store.getters.daily_sales },
    chartOptions() {
      const DATA = this.daily_sales;
      const BASE_URL = this.$store.getters.baseUrl;
      return {
        chart: {
          zoomType: 'x'
        },
        title: {
          text: 'Progressão do ticket médio real em 1 ano'
        },
        subtitle: {
          text: document.ontouchstart === undefined ?
            'Clique e arraste na área do gráfico para zoom -- cada ponto é um link para os pedidos pagos do dia clicado' :
            'Toque e arraste na área do gráfico para zoom -- cada ponto é um link para os pedidos pagos do dia clicado'
        },
        xAxis: {
          type: 'datetime'
        },
        tooltip: {
          dateTimeLabelFormats: {
            hour: '%Y %A, %e de %B,'
          }
        },
        yAxis: {
          title: {
            text: 'Em reais'
          },
          min: 0
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, Highcharts.getOptions().colors[0]],
                [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
              ]
            },
            marker: {
              radius: 2
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null
          },
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function () {
                  let date = new Date(this.x)

                  let day = date.getDate()
                  if (day.toString().length < 2)
                    day = '0' + day

                  let month = date.getMonth() + 1
                  if (month.toString().length < 2)
                    month = '0' + month

                  let year = date.getFullYear()

                  let formattedDate = day + '%2F' + month + '%2F' + year
                  // Essa url teve de ser posta na mão porque o sentry bloqueia com "429 TOO MANY REQUESTS"
                  window.open(
                    BASE_URL + '/shoppub-v2/relatorios_pedidos/reportorder/?status_resumido__exact=1&date_choice=1&date_period=10&date_range=&single_date=' + formattedDate,
                    '_blank'
                  )
                }
              }
            }
          },
          marker: {
            lineWidth: 1
          }
        },
        series: [{
          type: 'area',
          name: 'Ticket médio real (R$)',
          data: DATA
        }]
      }
    }
  }
}
</script>

<style>

</style>
